import React from 'react'

import ReactLoading from 'react-loading';

const LoadingModal = () => {
  return(
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100vw',
      height: '100vh',
      display: 'flex',
      zIndex: '1200',
      backgroundColor: '#00000091',
      justifyContent: 'center',
      alignItems: 'center'
    }}>
      <ReactLoading type={ 'spin' } color={ '#ffffff' } height={80} width={80} />
    </div>
  )
}

export default LoadingModal